module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--10--create-5e5ddb15.jpg";